import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';

import { dismissWant } from '../api/client.js';
import { djViewQueryKey } from '../api/queryKeys.js';

import type { ChannelId, DjView, PartySlug, TrackId } from '@mixwire/contracts';

type DismissVariables = {
  readonly slug: PartySlug;
  readonly channelId: ChannelId;
  readonly wantId: TrackId;
};

export const useDismissWant = (): UseMutationResult<DjView, Error, DismissVariables> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ slug, channelId, wantId }: DismissVariables) =>
      dismissWant(slug, channelId, wantId),
    onSuccess: (djView, { slug, channelId }) => {
      queryClient.setQueryData(djViewQueryKey(slug, channelId), djView);
    },
  });
};
